import { IconName } from '@blueprintjs/core';
import React from 'react';

interface IShortcut {
  label: string;
  hash: string;
  icon: IconName;
}
export const shortcuthashes = {
  history: 'asset-history',
  resources: 'asset-resources',
  documents: 'asset-documents',
  contacts: 'asset-contacts',

  updates: 'asset-updates',
};
export type ShortcutRefs = {
  [shortcut: string]: HTMLElement | null | undefined;
};
export function makeShortcutRefCallback(
  shortcutRefs: React.MutableRefObject<ShortcutRefs>,
  hash: string,
) {
  return (element: HTMLElement | null | undefined) => {
    shortcutRefs.current[hash] = element;
  };
}

export const shortcuts: IShortcut[] = [
  {
    label: 'History',
    hash: shortcuthashes.history,
    icon: 'time',
  },
  {
    label: 'Resources',
    hash: shortcuthashes.resources,
    icon: 'link',
  },
  {
    label: 'Documents',
    hash: shortcuthashes.documents,
    icon: 'document',
  },
  {
    label: 'Contacts',
    hash: shortcuthashes.contacts,
    icon: 'user',
  },
  {
    label: 'Updates',
    hash: shortcuthashes.updates,
    icon: 'import',
  },
];
